// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconCherries = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M14.695 16.952c.87.279 1.622.454 2.383.458.775.004 1.486-.17 2.282-.477l-.72-1.866c-.653.252-1.107.345-1.552.343-.46-.002-.983-.107-1.783-.363zm-7.617.458c-.761-.004-1.513-.18-2.383-.458l.61-1.905c.8.256 1.324.36 1.783.363.445.002.899-.09 1.551-.343l.721 1.866c-.796.307-1.507.481-2.282.477" />,
    <path
      fillRule="evenodd"
      d="M15 3h-2c0 2.18 1.085 4.074 2.355 6.17l.152.25c.314.516.64 1.051.946 1.605Q16.723 11 17 11a6 6 0 11-5 9.318 6 6 0 11-4.453-9.293c.307-.554.632-1.089.946-1.606l.152-.25C9.915 7.074 11 5.18 11 3H9V1h6zm-2 14a4 4 0 108 0 4 4 0 00-8 0m-1-3.318a6 6 0 00-2.456-2.118q.376-.644.796-1.334l.015-.024c.56-.925 1.16-1.917 1.645-2.99.486 1.073 1.084 2.065 1.645 2.99l.014.023q.422.69.797 1.335A6.03 6.03 0 0012 13.682M11 17a4 4 0 11-8 0 4 4 0 018 0"
    />
  );
export default SvgIconCherries;
